import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  restriction: z.enum(["none", "past_only", "future_only"]).default("none"),
});

export const datetimeField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "datetime",
  label: "Date and time",
  category: "date_time",
  icon: "CalendarClock",
  configSchema,
  valueSchema: (config, isRequired) => {
    const base = z
      .string()
      .refine((value) => !Number.isNaN(Date.parse(value)), "Enter a valid date and time")
      .superRefine((value, ctx) => {
        const parsed = new Date(value);
        const now = new Date();
        if (config.restriction === "past_only" && parsed > now) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Must be in the past" });
        }
        if (config.restriction === "future_only" && parsed < now) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Must be in the future" });
        }
      });
    return optionalUnlessRequired(base, isRequired);
  },
  defaultConfig: { restriction: "none" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  sortKind: "temporal",
  renderHints: {},
};
